export const EOrderPlaceType = {
  Local: 0,

  Delivery: 1,
} as const

export type EOrderPlaceType = (typeof EOrderPlaceType)[keyof typeof EOrderPlaceType]
